import { render, staticRenderFns } from "./create-moiequipment.vue?vue&type=template&id=427abc08&"
import script from "./create-moiequipment.vue?vue&type=script&lang=ts&"
export * from "./create-moiequipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports